module.exports = __webpack_public_path__ + "static/media/timetable-background.ab25acf8.png";